export function isCorrectDecimals(value: string, decimals: number) {
	const values = value.split('.')

	if (!values.length) {
		return false
	}

	if (values.length === 1 || !values[1]) {
		return true
	}

	return decimals >= values[1].length
}
